// extracted by mini-css-extract-plugin
export default {"container":"Xm-z","bubbleNav":"Ym-z","graphic":"Zm-z","contact":"_m-z"};